export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10605.86b49189.jpg";